/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetEodLogDtoDocument } from './GetEodLogDtoDocument';
import {
    GetEodLogDtoDocumentFromJSON,
    GetEodLogDtoDocumentFromJSONTyped,
    GetEodLogDtoDocumentToJSON,
} from './GetEodLogDtoDocument';

/**
 * 
 * @export
 * @interface GetEodLogDto
 */
export interface GetEodLogDto {
    /**
     * 
     * @type {number}
     * @memberof GetEodLogDto
     */
    id: number;
    /**
     * 
     * @type {GetEodLogDtoDocument}
     * @memberof GetEodLogDto
     */
    document?: GetEodLogDtoDocument | null;
    /**
     * 
     * @type {Date}
     * @memberof GetEodLogDto
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof GetEodLogDto
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof GetEodLogDto
     */
    user?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetEodLogDto
     */
    eventName: string;
    /**
     * 
     * @type {string}
     * @memberof GetEodLogDto
     */
    details?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetEodLogDto
     */
    companyNIP?: string | null;
}

/**
 * Check if a given object implements the GetEodLogDto interface.
 */
export function instanceOfGetEodLogDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "date" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "eventName" in value;

    return isInstance;
}

export function GetEodLogDtoFromJSON(json: any): GetEodLogDto {
    return GetEodLogDtoFromJSONTyped(json, false);
}

export function GetEodLogDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetEodLogDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'document': !exists(json, 'document') ? undefined : GetEodLogDtoDocumentFromJSON(json['document']),
        'date': (new Date(json['date'])),
        'type': json['type'],
        'user': !exists(json, 'user') ? undefined : json['user'],
        'eventName': json['eventName'],
        'details': !exists(json, 'details') ? undefined : json['details'],
        'companyNIP': !exists(json, 'companyNIP') ? undefined : json['companyNIP'],
    };
}

export function GetEodLogDtoToJSON(value?: GetEodLogDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'document': GetEodLogDtoDocumentToJSON(value.document),
        'date': (value.date.toISOString()),
        'type': value.type,
        'user': value.user,
        'eventName': value.eventName,
        'details': value.details,
        'companyNIP': value.companyNIP,
    };
}

